import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';
import { Answers } from '../models/answers.model';
import { Product, ArticleTypeEnum } from '../models/data.model';
import { Answer, Step } from '../models/qa.model';
import { StartupService } from './startup.service';
import { QuestionTypeEnum } from '../models/question-type';
import { QaService } from './qa.service';
import { Empty } from '../models/utils.model';
import { WoodTypeEnum } from '../models/wood-type';

@Injectable()
export class AnswerInfoService {

  constructor(private startupService: StartupService, private qaService: QaService) {
  }

  public getSelectedProject(): string {
    const questionTypeProjectGuid = this.getQuestionTypeGuid(QuestionTypeEnum.ProjectType);
    const selectedProject = this.qaService.answers.selectedAnswers.find(c => c.QuestionType === questionTypeProjectGuid);
    return selectedProject == null ? Empty.GuidValue : selectedProject.ProjectTypeFilter;
  }

  public getSelectedProjectTitle(): string {
    const questionTypeProjectGuid = this.getQuestionTypeGuid(QuestionTypeEnum.ProjectType);
    const selectedProject = this.qaService.answers.selectedAnswers.find(c => c.QuestionType === questionTypeProjectGuid);
    return selectedProject == null ? '' : selectedProject.DocumentPageTitle;
  }

  public getSelectedWoodGrain(): string {
    const questionTypeWoodGrainGuid = this.getQuestionTypeGuid(QuestionTypeEnum.WoodGrain);
    const selectedWoodGrain = this.qaService.answers.selectedAnswers.find(c => c.QuestionType === questionTypeWoodGrainGuid);
    return selectedWoodGrain == null ? Empty.GuidValue : selectedWoodGrain.WoodGrainFilter;
  }

  public getSelectedWoodType(): string {
    const woodTypeGuid = this.getQuestionTypeGuid(QuestionTypeEnum.WoodType);
    const selectedWoodType = this.qaService.answers.selectedAnswers.find(c => c.QuestionType === woodTypeGuid);
    return selectedWoodType == null ? Empty.GuidValue : selectedWoodType.WoodTypeFilter;
  }

  public getSelectedWoodCondition(): string {
    const woodConditionGuid = this.getQuestionTypeGuid(QuestionTypeEnum.WoodCondition);
    const selectedWoodType = this.qaService.answers.selectedAnswers.find(c => c.QuestionType === woodConditionGuid);
    return selectedWoodType == null ? Empty.GuidValue : selectedWoodType.WoodConditionFilter;
  }

  public getSelectedWoodDamage(): string {
    const woodDamageGuid = this.getQuestionTypeGuid(QuestionTypeEnum.WoodDamage);
    const selectedWoodDamage = this.qaService.answers.selectedAnswers.find(c => c.QuestionType === woodDamageGuid);
    return selectedWoodDamage == null ? Empty.GuidValue : selectedWoodDamage.WoodDamageFilter;
  }

  public getSelectedWoodLook(): string {
    const woodLookGuid = this.getQuestionTypeGuid(QuestionTypeEnum.StainGoal);
    const selectedWoodType = this.qaService.answers.selectedAnswers.find(c => c.QuestionType === woodLookGuid);
    return selectedWoodType == null ? Empty.GuidValue : selectedWoodType.WoodLookFilter;
  }

  public getQuestionTypeGuid(type: QuestionTypeEnum): string {
    return this.startupService.startupData.QuestionTypes
      .find(c => c.Name === type).ItemGuid;
  }

  public getArticleTypeGuid(type: ArticleTypeEnum): string {
    return this.startupService.startupData.ArticleTypes
      .find(c => c.ItemName === type).ItemGUID;
  }

  public getWoodTypeGuid(type: WoodTypeEnum): string {
    return this.startupService.startupData.WoodTypes
      .find(c => c.ItemName === type).ItemGUID;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/answer-info.service.ts